import { render } from "./WorkPreview.vue?vue&type=template&id=7596fc00"
import script from "./WorkPreview.vue?vue&type=script&lang=js"
export * from "./WorkPreview.vue?vue&type=script&lang=js"

import "./WorkPreview.vue?vue&type=style&index=0&id=7596fc00&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__